import { Button, Form, Card, Dropdown } from "react-bootstrap";
import { ChevronLeft, Save, Printer, Edit, X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { DatePicker, Grid, Input, List, Popover } from "antd";
import { CalendarOutlined, SearchOutlined } from "@ant-design/icons";
import classNames from "classnames";
import dayjs from "dayjs";
import SaveRXModal from "./SaveRXModal";
import { addConsultData } from "../../services/doctor/consultant/consultant";
import { getPrintSettings } from "../../services/doctor/print_settings/printSettings";
import { useAuth } from "../../services/authentication_API/authService";
import { getShifts } from "../../services/doctor/shift schedule/shift_schedule";
import AddReferMOdal from "./AddReferMOdal";
import { getreferDoctor } from "../../services/doctor/referDoctor/referDoctor";
import { getPremedicalHistoryData } from "../../services/doctor/medical_history/medicalHistory";
import { getVitals } from "../../services/doctor/vitals/vitals";
const { useBreakpoint } = Grid;
const referralOptions = [
  "Arthroscopic Surgeon Opinion ()",
  "Civil Rajkot ()",
  "Dang Laboratories (Lab)",
  "Dr Jogi Sir (General surgeon )",
  "Dr. Dharam Chandrani ()",
  "Dr. Kaushal Patel (Arthroscopic surgeon )",
  "Dr. Kevin Ajudiya (General surgeon )",
  "Dr. Akash Makadiya ()",
  "Dr. Charmi (General surgery )",
  "Dr. Chirag Thummar (Gynaecologist )",
  "Dr. Dushvant Sakadiya ()",
];
export default function PreviewRX() {
  const navigate = useNavigate();
  const { formData } = useLocation().state || {};
  const screens = useBreakpoint();
  const printRef = useRef(null);
  const [settings, setSettings] = useState();
  const { userData } = useAuth();
  const [show, setShow] = useState(false);

  const fetchPrintSettings = async () => {
    try {
      const result = await getPrintSettings(userData?.id);
      if (result.success) {
        console.log("Fetched Data:", result.data);
        const formData = result?.data;
        console.log("Formatted Data:", formData);
        setSettings(formData);
      } else {
        console.error(
          "Error:",
          result.error || "Failed to fetch Print Settings"
        );
      }
    } catch (err) {
      console.error("Exception:", err.message);
    }
  };

  // ✅ CSS Print Media Query Approach (Most Reliable)
  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open(
      "about:blank", // THIS FIXES SAFARI
      "printWin",
      "popup=yes,width=800,height=900"
    );
    printWindow.document.write(`
    <html>
      <head>
        <title>Prescription</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
          crossorigin="anonymous"
        />
        <style>
          @page {
            size: A4 portrait;
            margin: 0;
          }
          body, table, div, span, p {
            font-size: 16px !important;
          }

          html, body {
            width: 210mm;
            height: auto;
            margin: 0;
            padding: 0;
            background: white;
            overflow: hidden;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .print-wrapper {
            width: 100vw;
            max-width: 210mm;
            margin: 0 auto;
            box-sizing: border-box;
            padding: ${settings.prescription_print_header_margin || 0}% ${settings.prescription_print_right_margin || 0
      }% ${settings.prescription_print_footer_margin || 0}% ${settings.prescription_print_left_margin || 0
      }%;
            background: white;
            transform-origin: top center;
          }
          .table>:not(caption)>*>* {
            padding: .2rem .2rem;
            color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
            background-color: var(--bs-table-bg);
            border-bottom-width: var(--bs-border-width);
            box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
          }

          table {
            width: 100%;
            border-collapse: collapse;

          }
            .thick-border table,
            .thick-border th,
            .thick-border td {
            border-width: 0.5px !important;
            border-color: #2c2c2cff !important;
          }

           td {
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;
          }

          th {
            background: #f8f9fa;
            text-align: left;
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;

          }

          .no-print { display: none !important; }
          hr { border: 0; border-top: 1px solid #ccc; margin: 20px 0; }
        </style>
      </head>
      <body>
        <div id="print-area" class="print-wrapper">
          ${printContents}
        </div>
        <script>
          window.onload = function() {
            const content = document.getElementById('print-area');
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

            // Get A4 height in pixels at 96 DPI
            const A4_HEIGHT_PX = 1122; // 297mm ≈ 1122px
            const contentHeight = content.scrollHeight;

            // If content overflows one A4 page, scale it down
            if (contentHeight > A4_HEIGHT_PX) {
              const scale = A4_HEIGHT_PX / contentHeight;
              content.style.transform = 'scale(' + scale + ')';
              content.style.transformOrigin = 'top center';
              document.body.style.height = A4_HEIGHT_PX + 'px';
            } else if (isIOS) {
              // Avoid unnecessary downscaling (causes side gaps)
              content.style.transform = 'scale(1)';
              content.style.transformOrigin = 'top center';
              document.body.style.margin = '0';
              document.body.style.padding = '0';
              content.style.width = '100vw';
            }


            setTimeout(() => {
              window.focus();
              window.print();
              let attempts = 0;

function tryClose() {
  try {
    window.close();

    if (!window.closed && attempts < 10) {
      attempts++;
      setTimeout(tryClose, 300);
    }
  } catch (e) {
    if (attempts < 10) {
      attempts++;
      setTimeout(tryClose, 300);
    }
  }
}

window.onafterprint = tryClose;

// failsafe auto close after 1 second
setTimeout(tryClose, 1000);

            }, 500);
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();

        let attempts = 0;
        function tryClose() {
          try {
            printWindow.close();
            if (!printWindow.closed && attempts < 10) {
              attempts++;
              setTimeout(tryClose, 400);
            }
          } catch {
            if (attempts < 10) {
              attempts++;
              setTimeout(tryClose, 400);
            }
          }
        }

        // Safari: onafterprint rarely works, but include it
        printWindow.onafterprint = tryClose;

        // Fallback close
        setTimeout(tryClose, 1500);
      }, 300);
    };
  };
  const [hoveredSection, setHoveredSection] = useState(null);
  const {
    id,
    patient,
    doctor,
    symptoms,
    findings,
    diagnosis,
    medicines,
    note,
    investigations,
    instructions,
    procedures,
    prescription_notes,
    doctor_notes,
    follow_up_date,
    follow_up_notes,
    refer_doctor,
    refer_doctor_notes
  } = formData;

  const [selectedFollowUp, setSelectedFollowUp] = useState(follow_up_date);
  const [followUpNotes, setFollowUpNotes] = useState(follow_up_notes);
  const [formatedFollowupDate, setformatedFollowupDate] = useState(null);
  const [saveRx, setSaveRx] = useState(null);
  const [printRx, setprintRx] = useState(null);
  const [shifts, setShifts] = useState([]);
  const [referDoctorList, setReferDoctorList] = useState([]);
  const [medicalHistory, setMedicalHistory] = useState([]);
  const [vitalsData, setVitalsData] = useState(null);

  console.log("medicines data in preview rx page :", medicines);
  console.log("patients data in preview rx page :", patient);

  const followUpsRow1 = ["3d", "5d", "1w", "2w", "1m"];
  const followUpsRow2 = ["45d", "3m", "6m", "12m"];
  const isFirstRender = useRef(true);

  const addConsultantData = async () => {
    try {
      const result = await addConsultData({
        ...formData,
        follow_up_date: selectedFollowUp,
        status: "Done",
        follow_up_notes: followUpNotes,
        refer_doctor_id: selectedDoctor?.id,
        refer_doctor_notes: referralInstruction,
        print_html_view: printRef.current.innerHTML,
      });
      console.log(result)
      if (result.success) {
        console.log("auto saved:", result);
        

      }
    } catch (err) {
      console.error("Error:", err.message);
    }
  };
  const currentDate = dayjs().format("YYYY-MM-DD");

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    addConsultantData();
  }, [saveRx, printRx]);

  const fetchShifts = async () => {
    try {
      const result = await getShifts(userData?.id, selectedFollowUp);
      if (result.success) {
        console.log("Fetched Data:", result.data);
        const formData = result?.data;

        setShifts(formData);
      } else {
        console.error("Error:", result.error || "Failed to fetch shifts");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    }
  };
  const fetchReferDoctor = async () => {
    try {
      const result = await getreferDoctor("", userData?.id);
      if (result.success) {
        const formattedData = result?.data;
        setReferDoctorList(formattedData);
      } else {
        // Optionally handle error
        setReferDoctorList([]);
      }
    } catch (err) {
      // Optionally handle error
      setReferDoctorList([]);
    }
  };


  const fetchvitals = async () => {

    try {
      let result = await getVitals(
        id
      );
      console.log("Fetched Vitals Data:", result);

      if (result?.success) {
        setVitalsData(result?.data || null);
      } else {
        setVitalsData(null);
      }
    } catch (error) {
      console.error("Error fetching vitals:", error);
    }

  };


  console.log(vitalsData)
  const fetchPreMedicalHistory = async () => {
    try {
      const result = await getPremedicalHistoryData(patient?.id);

      if (!result?.success) return;

      const { consult_medical_histories } = result.data || {};
      setMedicalHistory(result.data || {});

    } catch (error) {
      console.error("Error fetching pre-medical history:", error);
    }
  };

  useEffect(() => {
    fetchPreMedicalHistory();
    fetchPrintSettings();
    fetchReferDoctor();
    fetchvitals();

  }, []);

  useEffect(() => {
    fetchShifts();
  }, [selectedFollowUp]);
  let printChild = null;

  const testPopup = () => {
    const html = printRef.current.innerHTML;

    // Remove old iframe
    const oldIframe = document.getElementById("print-iframe");
    if (oldIframe) oldIframe.remove();

    // Create iframe (visible but transparent)
    const iframe = document.createElement("iframe");
    iframe.id = "print-iframe";
    iframe.style.position = "fixed";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "100vw";
    iframe.style.height = "100vh";
    iframe.style.opacity = "0";
    iframe.style.pointerEvents = "none";
    iframe.style.zIndex = "-1";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`
    <html>
      <head>
        <title>Prescription</title>
        
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no"/>

        <link 
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
          crossorigin="anonymous"
        />

        <style>
          @page {
            size: A4 portrait;
            margin: 0;
          }

          body, table, div, span, p {
            font-size: 16px !important;
          }

          html, body {
            width: 210mm;
            height: auto;
            margin: 0;
            padding: 0;
            background: white;
            overflow: hidden;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .print-wrapper {
            width: 100vw;
            max-width: 210mm;
            margin: 0 auto;
            box-sizing: border-box;
            padding: ${settings.prescription_print_header_margin || 0}% 
                     ${settings.prescription_print_right_margin || 0}% 
                     ${settings.prescription_print_footer_margin || 0}% 
                     ${settings.prescription_print_left_margin || 0}%;
            background: white;
            transform-origin: top center;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }
          .table>:not(caption)>*>* {
            padding: .2rem .2rem;
            color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
            background-color: var(--bs-table-bg);
            border-bottom-width: var(--bs-border-width);
            box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
          }  
          
          .thick-border table,
          .thick-border th,
          .thick-border td {
            border-width: 0.5px !important;
            border-color: #2c2c2cff !important;
          }

          td {
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;
          }

          th {
            background: #f8f9fa;
            text-align: left;
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;
          }

          .no-print { display: none !important; }

          hr { 
            border: 0; 
            border-top: 1px solid #ccc; 
            margin: 20px 0; 
          }
        </style>
      </head>

      <body>
        <div class="print-wrapper">
          ${html}
        </div>
      </body>
    </html>
  `);

    doc.close();

    // iPad Safari + Chrome iOS wait logic
    const waitUntilReady = () => {
      const state = doc.readyState;

      if (state === "complete" || state === "interactive") {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          });
        });
      } else {
        setTimeout(waitUntilReady, 50);
      }
    };

    waitUntilReady();
  };
  const isIpadSafari = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    // iPad Safari = iPad + WebKit + NOT Chrome
    const isIpad =
      /iPad/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isWebkit = /WebKit/.test(ua);
    const isChrome = /CriOS/.test(ua); // Chrome on iOS

    return isIpad && isWebkit && !isChrome;
  };

  const [popoverVisible, setPopoverVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(refer_doctor || null);
  const [referralInstruction, setReferralInstruction] = useState(refer_doctor_notes || "");
  const [editDoctorData, setEditDoctorData] = useState(null);
  const filteredOptions = referDoctorList.filter((option) =>
    option.doctor_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [doctorToEdit, setDoctorToEdit] = useState(null);
  // Handle selecting an option from the list
  const handleSelect = (doctorObject) => {
    setSelectedDoctor(doctorObject);
    setPopoverVisible(false); // Close the popover on selection
    setDoctorToEdit(null); // Ensure edit mode is off
  };
  const LONG_PRESS_TIME = 600;
  const MOVE_THRESHOLD = 8;


  // The content of the popover (Search + List)
  const popoverContent = (
    <div style={{ width: 300 }}>
      <Input
        placeholder="Search"
        prefix={<SearchOutlined />}
        style={{ marginBottom: 8 }}
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
      />

      <List
        size="small"
        dataSource={filteredOptions}
        renderItem={(item) => {
          let pressTimer = null;
          let touchStartY = 0;
          let moved = false;
          let longPressed = false;

          return (
            <List.Item
              key={item.id}

              /* 🖱️ Desktop */
              onMouseDown={() => {
                longPressed = false;
                pressTimer = setTimeout(() => {
                  longPressed = true;
                  handleEdit(item);
                }, LONG_PRESS_TIME);
              }}

              onMouseUp={() => {
                if (pressTimer && !longPressed) {
                  clearTimeout(pressTimer);
                  handleSelect(item);
                }
                pressTimer = null;
              }}

              onMouseLeave={() => {
                if (pressTimer) {
                  clearTimeout(pressTimer);
                  pressTimer = null;
                }
              }}

              /* 📱 Mobile */
              onTouchStart={(e) => {
                moved = false;
                longPressed = false;
                touchStartY = e.touches[0].clientY;

                pressTimer = setTimeout(() => {
                  if (!moved) {
                    longPressed = true;
                    handleEdit(item);
                  }
                }, LONG_PRESS_TIME);
              }}

              onTouchMove={(e) => {
                const diff = Math.abs(e.touches[0].clientY - touchStartY);

                if (diff > MOVE_THRESHOLD) {
                  moved = true;
                  if (pressTimer) {
                    clearTimeout(pressTimer);
                    pressTimer = null;
                  }
                }
              }}

              onTouchEnd={() => {
                if (pressTimer && !moved && !longPressed) {
                  clearTimeout(pressTimer);
                  handleSelect(item);
                }
                pressTimer = null;
              }}

              style={{
                cursor: "pointer",
                fontWeight: "bold",
                userSelect: "none",
                touchAction: "pan-y",
              }}
            >
              {item.doctor_name}
              {item.speciality && ` (${item.speciality})`}
            </List.Item>

          );
        }}
        style={{
          maxHeight: 300,
          overflowY: "auto",
          touchAction: "pan-y",
        }}
      />
    </div>
  );
  const handleEdit = (doctorObject) => {
    setDoctorToEdit(doctorObject); // Set the data to be edited
    setShow(true);                 // Open the modal
    setPopoverVisible(false);      // Close the popover
  };
  const handleAddButtonClick = () => {
    setDoctorToEdit(null); // Ensure Add mode
    setShow(true);
  };
  const handleModalClose = (updatedData) => {
    setShow(false);
    setDoctorToEdit(null); // Crucial: Reset edit data when closing

    // Optional: Re-fetch doctor list if updatedData is available
    if (updatedData) {
      handleSelect(updatedData);
      fetchReferDoctor();
    }
  };
  return (
    <div className="min-vh-100 bg-light">
      <div className="d-flex">
        {/* Left Sidebar - Marked as no-print */}
        <div
          className="bg-white border-end p-4 no-print"
          style={{ width: "auto" }}
        >
          {/* ... your existing sidebar content ... */}
          <div className="mb-4">
            <h4>Follow Up Date : </h4>
          </div>

          <div className="mb-4">
            {selectedFollowUp && (
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0 fw-medium">
                  Follow Up (
                  {selectedFollowUp
                    ? dayjs(selectedFollowUp).format("DD MMM, YYYY")
                    : null}
                  )
                </h6>
                <Button
                  variant="link"
                  className="p-0 small text-primary"
                  onClick={() => setSelectedFollowUp(null)}
                >
                  Reset
                </Button>
              </div>
            )}
            {shifts.length > 0 ? null : (
              <h6 className="mb-3 fw-medium " style={{ color: "red" }}>
                Clinic is closed on{" "}
                {selectedFollowUp
                  ? dayjs(selectedFollowUp).format("dddd MMM DD, YYYY")
                  : null}
              </h6>
            )}

            {/* Row 1 */}
            <div
              className="d-grid gap-2 mb-3"
              style={{ gridTemplateColumns: "repeat(5, 1fr)" }}
            >
              {followUpsRow1.map((val) => (
                <Button
                  key={val}
                  size="sm"
                  variant={
                    formatedFollowupDate === val
                      ? "primary"
                      : "outline-secondary"
                  }
                  onClick={() => {
                    setSelectedFollowUp(val);
                    setformatedFollowupDate(val);
                    let baseDate = dayjs(formData.appointment_date);
                    let newDate = null;

                    switch (val) {
                      case "3d":
                        newDate = baseDate.add(3, "day");
                        break;
                      case "5d":
                        newDate = baseDate.add(5, "day");
                        break;
                      case "1w":
                        newDate = baseDate.add(1, "week");
                        break;
                      case "2w":
                        newDate = baseDate.add(2, "week");
                        break;
                      case "1m":
                        newDate = baseDate.add(1, "month");
                        break;
                      default:
                        newDate = null;
                    }

                    setSelectedFollowUp(
                      newDate ? newDate.format("YYYY-MM-DD") : null
                    );
                  }}
                >
                  {val}
                </Button>
              ))}
            </div>

            {/* Row 2 */}
            <div
              className="d-grid gap-2 mb-3"
              style={{ gridTemplateColumns: "repeat(4, 1fr)" }}
            >
              {followUpsRow2.map((val) => (
                <Button
                  key={val}
                  size="sm"
                  variant={
                    formatedFollowupDate === val
                      ? "primary"
                      : "outline-secondary"
                  }
                  onClick={() => {
                    setSelectedFollowUp(val);
                    setformatedFollowupDate(val);
                    let baseDate = dayjs(formData.appointment_date);
                    let newDate = null;

                    switch (val) {
                      case "45d":
                        newDate = baseDate.add(45, "day");
                        break;
                      case "3m":
                        newDate = baseDate.add(3, "month");
                        break;
                      case "6m":
                        newDate = baseDate.add(6, "month");
                        break;
                      case "12m":
                        newDate = baseDate.add(12, "month");
                        break;
                      default:
                        newDate = null;
                    }

                    setSelectedFollowUp(
                      newDate ? newDate.format("YYYY-MM-DD") : null
                    );
                  }}
                >
                  {val}
                </Button>
              ))}
            </div>

            {/* Row 3 */}
            <div
              className="d-grid gap-2 mb-3"
              style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
            >
              <DatePicker
                style={{ width: "100%" }}
                value={
                  selectedFollowUp
                    ? dayjs(selectedFollowUp, "YYYY-MM-DD")
                    : null
                }
                placeholder="Select Date"
                suffixIcon={<CalendarOutlined />}
                onChange={(date) => {
                  setSelectedFollowUp(date ? date.format("YYYY-MM-DD") : null);
                }}
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
              />
            </div>

            <Card>
              <h4 className="mb-2">Follow Up Notes</h4>
              <Form.Control
                as="textarea"
                rows={screens.xs ? 2 : 3}
                placeholder="This note is printed on Priscription.."
                value={followUpNotes}
                onChange={(e) => setFollowUpNotes(e.target.value)}
              />
            </Card>
          </div>
          {selectedDoctor ? (
            // State 2: Doctor Selected (Expanded UI)
            <div className="border-bottom border-top py-2  mb-4">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <h5 className="mb-0 fw-medium">
                  Refer to:{" "}
                  <span className="fw-bold">{selectedDoctor?.doctor_name}</span>
                </h5>
                <Button
                  variant="link"
                  className="p-0 text-danger"
                  onClick={() => {
                    setSelectedDoctor(null); // Reset doctor
                    // setReferralInstruction("");        // Clear instructions
                  }}
                >
                  <X size={20} />
                </Button>
              </div>

              {/* Instruction Text Box */}
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Enter referral instructions here"
                value={referralInstruction}
                onChange={(e) => setReferralInstruction(e.target.value)}
                style={{ borderRadius: "0.25rem" }}
              />
            </div>
          ) : (
            // State 1: No Doctor Selected (Original Popover Trigger)
            <Popover
              content={popoverContent}
              trigger="click"
              open={popoverVisible}
              onOpenChange={setPopoverVisible}
              placement="right"
              title={
                <div
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h4>Refer to</h4>
                  </div>
                  <Button
                    onClick={handleAddButtonClick}
                    style={{
                      backgroundColor: "transparent",
                      border: "1px",
                      color: "green",
                      fontWeight: "normal",
                      fontSize: "inherit",
                      cursor: "pointer",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    Add
                  </Button>
                </div>
              }
            >
              {/* The component that triggers the popover */}
              <div
                className="border-bottom border-top px-3"
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-1 mt-1 fw-medium">Refer to</h4>
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 fw-medium me-1">Selecte</h4>
                    <span style={{ fontSize: "1.9rem" }}>&gt;</span>{" "}
                  </div>
                </div>
              </div>
            </Popover>
          )}
        </div>

        {/* Main Content - This will be printed */}
        <div className="flex-grow-1" style={{ padding: "1% 1%" }}>
          <div
            ref={printRef}
            id="print-area"
            className="bg-white rounded shadow-sm border p-4"
            style={{ marginBottom: "70px" }}
          >
            {/* Patient Info */}
            <div className="d-flex justify-content-between mb-2">
              <div>
                <div className="mb-0">
                  <strong>Name: </strong>
                  <span>
                    {patient.first_name} {patient.middle_name}{" "}
                    {patient.last_name}
                  </span>
                </div>
                <div className="mb-0">
                  <strong>Age/Sex: </strong>
                  <span>
                    {patient.age?.replace(/\s*0M$/, '') || "N/A"} / {patient.gender?.[0]}
                  </span>
                </div>
                <div>
                  <strong>Office ID: </strong>
                  <span>{patient?.office_id}</span>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <div className="text-start">
                  <div className="mb-0">
                    <strong>Date: </strong>
                    <span>
                      {dayjs(formData.appointment_date).format("DD-MM-YYYY")}
                      {" / "}
                      {formData.appointment_time}
                    </span>
                  </div>
                  <div className="mb-0">
                    <strong>Mobile: </strong>
                    <span>{patient.mobile}</span>
                  </div>
                  <div>
                    <strong>Address: </strong>
                    <span>{patient?.street || "N/A"}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr style={{ margin: "5px 0px" }}></hr>

            {/* Clinical Info */}
            <div className="mb-0">
              {symptoms?.length > 0 && (
                <div className="mb-0">
                  <div
                    className="flex items-center gap-2"
                    onMouseEnter={() => setHoveredSection("symptoms")}
                    onMouseLeave={() => setHoveredSection(null)}
                  >
                    <strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Symptoms:
                    </strong>
                    {symptoms
                      .map((s) => {
                        const details = [s.note, s.since, s.severity]
                          .filter(Boolean)
                          .join(" - ");
                        return details ? `${s.name} (${details})` : s.name;
                      })
                      .join(", ")}
                    <span
                      className={classNames(
                        "text-blue-500 text-sm no-print mr-2",
                        {
                          "d-inline": hoveredSection === "symptoms",
                          "d-none": hoveredSection !== "symptoms",
                        }
                      )}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/start-consult", {
                          state: {
                            doctorID: doctor?.id,
                            appointmentID: id,
                            activeSection: "symptoms",
                          },
                        })
                      }
                    >
                      <Edit size={18} />
                    </span>
                  </div>
                </div>
              )}

              {/* ... rest of your clinical info sections (findings, diagnosis, etc.) ... */}
              {findings?.length > 0 && (
                <div className="mb-0">
                  <div
                    className="flex items-center gap-2"
                    onMouseEnter={() => setHoveredSection("findings")}
                    onMouseLeave={() => setHoveredSection(null)}
                    style={{ display: "flex" }}
                  >
                    <strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Findings:
                    </strong>
                    {findings
                      .map((f) => {
                        const details = [f.note, f.since, f.severity]
                          .filter(Boolean)
                          .join(" - ");
                        return details ? `${f.name} (${details})` : f.name;
                      })
                      .join(", ")}
                    <span
                      className={classNames(
                        "text-blue-500 text-sm no-print mr-2",
                        {
                          "d-inline": hoveredSection === "findings",
                          "d-none": hoveredSection !== "findings",
                        }
                      )}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/start-consult", {
                          state: {
                            doctorID: doctor?.id,
                            appointmentID: id,
                            activeSection: "findings",
                          },
                        })
                      }
                    >
                      <Edit size={18} />
                    </span>
                  </div>
                </div>
              )}
              {medicalHistory?.consult_medical_histories?.some(
                (category) => category.medical_histories?.length > 0
              ) && (
                  <div >
                    <div style={{ display: "block" }}>
                      <strong>Medical History:</strong>
                    </div>

                    {medicalHistory?.consult_medical_histories
                      ?.filter((cat) => cat.medical_histories?.length > 0)
                      .map((category, idx) => {
                        const isLifestyle = category.name.includes("Lifestyle");

                        return (
                          <>
                            <div
                              key={category.id}
                              style={{
                                display: "inline-block",
                                marginRight: "10px",
                              }}
                            >
                              {/* Underlined Category Label */}
                              <span style={{ textDecoration: "underline" }}>
                                {category.name.replace("H/O ", "")}
                              </span>
                              :{" "}
                              {category.medical_histories.map((item, i) => {
                                const itemText = <strong>{item.name}</strong>;

                                // Correctly combine Year and Month: "4 Years 3 Months"
                                const yearPart = item.since_year
                                  ? `${item.since_year} Years`
                                  : "";
                                const monthPart = item.since_month
                                  ? `${item.since_month} Months`
                                  : "";
                                const combinedTime = [yearPart, monthPart]
                                  .filter(Boolean)
                                  .join(" ");
                                const sinceYear = item.since_when_year || 0;
                                let details = "";
                                if (combinedTime) {
                                  // Standard format: "since- 4 Years 3 Months"
                                  details = `since- ${combinedTime}`;
                                }
                                if (sinceYear) {
                                  details += details ? `, ` : ``;
                                  details += `Since ${sinceYear}`;
                                }
                                if (item?.family_relation) {
                                  details += details ? `, ` : ``;
                                  details += item.family_relation;
                                }
                                if (item.note) {
                                  details += details ? `, ` : ``;
                                  details += `${item.note}`;
                                }

                                // Family Relation logic

                                return (
                                  <span key={item.id}>
                                    {itemText}
                                    {details ? `, ${details}` : ""}
                                    {i < category.medical_histories.length - 1
                                      ? ", "
                                      : ""}
                                  </span>
                                );
                              })}
                              {/* Comma between categories */}
                              {idx <
                                medicalHistory?.consult_medical_histories?.filter(
                                  (c) => c.medical_histories.length > 0
                                ).length -
                                1
                                ? ", "
                                : ""}
                            </div>
                            <br />
                          </>
                        );
                      })}
                  </div>
                )}
              {medicalHistory?.hospitalization?.length > 0 && (
                <div className="mb-0">
                  <strong>hospitalization: </strong>
                  <span className="ms-3 ">{medicalHistory?.hospitalization}</span>
                </div>
              )}
              {medicalHistory?.significant_history?.length > 0 && (
                <div className="mb-0">
                  <strong>Significant History: </strong>
                  <span className="ms-3 ">{medicalHistory?.significant_history}</span>
                </div>
              )}

              {diagnosis?.length > 0 && (
                <div className="mb-0">
                  <div
                    className="flex items-center gap-2"
                    onMouseEnter={() => setHoveredSection("diagnosis")}
                    onMouseLeave={() => setHoveredSection(null)}
                    style={{ display: "flex" }}
                  >
                    <strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Diagnosis:
                    </strong>
                    {diagnosis
                      .map((d) => {
                        const details = [d.note, d.location, d.description]
                          .filter(Boolean)
                          .join(" - ");
                        return details ? `${d.name} (${details})` : d.name;
                      })
                      .join(", ")}
                    <span
                      className={classNames(
                        "text-blue-500 text-sm no-print mr-2",
                        {
                          "d-inline": hoveredSection === "diagnosis",
                          "d-none": hoveredSection !== "diagnosis",
                        }
                      )}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/start-consult", {
                          state: {
                            doctorID: doctor?.id,
                            appointmentID: id,
                            activeSection: "diagnosis",
                          },
                        })
                      }
                    >
                      <Edit size={18} />
                    </span>
                  </div>
                </div>
              )}
              {/* Vitals Section */}
              {/* Vitals Evaluation Block */}
              {vitalsData && (
                <div className="mb-0 vitals-container">
                  {(() => {
                    const vitalsList = [];

                    if (vitalsData.pulse)
                      vitalsList.push(`<strong>Pulse</strong>: ${vitalsData.pulse} /min`);

                    if (vitalsData.systolic || vitalsData.diastolic)
                      vitalsList.push(`<strong>Systolic</strong>: ${vitalsData.systolic}`);

                    if ( vitalsData.diastolic)
                      vitalsList.push(`<strong>Diastolic</strong>: ${vitalsData.diastolic}`);

                    if (vitalsData.spo2)
                      vitalsList.push(`<strong>SPO2</strong>: ${vitalsData.spo2}%`);

                    if (vitalsData.temperature)
                      vitalsList.push(`<strong>Temp</strong>: ${vitalsData.temperature} °F`);

                    if (vitalsData.spot_blood_sugar)
                      vitalsList.push(`<strong>Spot Blood Sugar</strong>: ${vitalsData.spot_blood_sugar} mg/dl`);

                    if (vitalsData.height)
                      vitalsList.push(`<strong>Height</strong>: ${vitalsData.height} cm`);

                    if (vitalsData.weight)
                      vitalsList.push(`<strong>Weight</strong>: ${vitalsData.weight} kg`);

                    if (vitalsData.ofc)
                      vitalsList.push(`<strong>OFC</strong>: ${vitalsData.ofc} cm`);

                    if (vitalsData.waist)
                      vitalsList.push(`<strong>Waist</strong>: ${vitalsData.waist} cm`);

                    if (vitalsData.hip)
                      vitalsList.push(`<strong>Hip</strong>: ${vitalsData.hip} cm`);

                    if (vitalsData.pefr)
                      vitalsList.push(`<strong>PEFR</strong>: ${vitalsData.pefr} L/min`);

                    return vitalsList.length > 0 ? (
                      <span
                        className=""
                        style={{ fontSize: "16px" }}
                        dangerouslySetInnerHTML={{
                          __html: `<strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Vitals:
                    </strong> ` + vitalsList.join(", ")
                        }}
                      />
                    ) : (
                      null
                    );
                  })()}
                </div>
              )}
            </div>

            {/* Prescription Table */}
            {medicines?.length > 0 && (
              <div className="mb-0">
                <div
                  className="flex items-center gap-2"
                  onMouseEnter={() => setHoveredSection("medicines")}
                  onMouseLeave={() => setHoveredSection(null)}
                  style={{ display: "flex" }}
                >
                  <span
                    className={classNames(
                      "text-blue-500 text-sm cursor-pointer no-print mr-2",
                      {
                        "d-inline": hoveredSection === "medicines",
                        "d-none": hoveredSection !== "medicines",
                      }
                    )}
                    onClick={() =>
                      navigate("/start-consult", {
                        state: {
                          doctorID: doctor?.id,
                          appointmentID: id,
                          activeSection: "medicines",
                        },
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <Edit size={20} />
                  </span>
                </div>
                <table
                  className="table table-bordered mt-2 thick-border"
                  style={{ marginBottom: "5px" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "4%", textAlign: "center" }}>
                        <strong>Rx</strong>
                      </th>
                      <th style={{ width: "25%" }}>
                        <strong>નામ</strong>
                      </th>
                      <th style={{ width: "23%" }}>
                        <strong>આવર્તન</strong>
                      </th>
                      <th style={{ width: "8%" }}>
                        <strong>સમયગાળો</strong>
                      </th>
                      <th style={{ width: "26%" }}>
                        <strong>નોંધ</strong>
                      </th>
                      <th style={{ width: "4%" }}>
                        <strong>count</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {medicines?.map((med, idx) =>
                      med.doses?.map((dose, doseIdx) => (
                        <tr key={`${med.id}-${doseIdx}`}>
                          {doseIdx === 0 && (
                            <td
                              rowSpan={med.doses.length}
                              className="text-center"
                            >
                              {idx + 1}
                            </td>
                          )}
                          {doseIdx === 0 && (
                            <td rowSpan={med.doses.length}>
                              {med?.doses[0].type}{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {med?.name}
                              </span>
                            </td>
                          )}
                          <td>
                            {dose?.type_unit_ui == "Default" &&
                              dose?.default_timing_instruction ? (
                              <>
                                {(() => {
                                  const { Breakfast, Lunch, Dinner } =
                                    dose.default_timing_instruction || {};
                                  const q = dose.quantity || 0;
                                  const breakfastDose = Breakfast ? q : 0;
                                  const lunchDose = Lunch ? q : 0;
                                  const dinnerDose = Dinner ? q : 0;
                                  const unitString =
                                    dose?.type &&
                                      !["Tablet", "Capsule"].includes(dose.type)
                                      ? ` ${dose?.unit || ""}`
                                      : "";

                                  const dosageResult =
                                    `${breakfastDose}${unitString} - ${lunchDose}${unitString} - ${dinnerDose}${unitString}`.trim();

                                  // Check if index is not 0 (Note: Ensure 'index' is available from your .map() scope)
                                  return (
                                    <span>
                                      {doseIdx !== 0 ? (
                                        <>
                                          <u>Then</u> {dosageResult}
                                        </>
                                      ) : (
                                        dosageResult
                                      )}
                                    </span>
                                  );
                                })()}
                                <br />
                              </>
                            ) : dose?.type_unit_ui == "Alternate" &&
                              dose?.default_timing_instruction ? (
                              <>
                                {(() => {
                                  const timingKeys = Object.keys(
                                    dose?.default_timing_instruction || {}
                                  );
                                  const key = timingKeys[0];
                                  let dosageResult = ""; // Initialize a variable to hold our text

                                  // 1. Determine the Gujarati text based on the key
                                  if (key === "Once") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દિવસ માં ૧ વાર`;
                                  } else if (key === "Twice") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દિવસ માં ૨ વાર`;
                                  } else if (key === "Thrice") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દિવસ માં ૩ વાર`;
                                  } else if (key === "4h") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દર ૪ કલાકે`;
                                  } else if (key === "6h") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દર ૬ કલાકે`;
                                  } else if (key === "8h") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દર ૮ કલાકે`;
                                  } else if (key === "12h") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દર ૧૨ કલાકે`;
                                  } else if (key === "48h") {
                                    dosageResult = `${dose?.quantity} ${dose?.unit} દર ૨ દિવસે`;
                                  } else {
                                    // Default fallback
                                    dosageResult = `${dose?.quantity} ${dose?.unit
                                      } ${key || ""}`;
                                  }

                                  // 2. Single return statement that handles the "Then" logic
                                  return (
                                    <span>
                                      {doseIdx !== 0 ? (
                                        <>
                                          <u>Then</u> {dosageResult}
                                        </>
                                      ) : (
                                        dosageResult
                                      )}
                                    </span>
                                  );
                                })()}
                              </>
                            ) : (
                              <>
                                {dose?.quantity} {dose?.unit}
                              </>
                            )}
                          </td>
                          <td>
                            {(() => {
                              const duration =
                                dose.duration?.toLowerCase() || "";
                              if (
                                duration.includes("d") ||
                                duration.includes("day")
                              ) {
                                const num = duration.match(/\d+/)?.[0];
                                return num ? `${num} દિવસ` : "1 દિવસ";
                              } else if (
                                duration.includes("w") ||
                                duration.includes("week")
                              ) {
                                const num = duration.match(/\d+/)?.[0];
                                return num ? `${num} અઠવાડિયા` : "1 અઠવાડિયા";
                              } else if (
                                duration.includes("m") ||
                                duration.includes("month")
                              ) {
                                const num = duration.match(/\d+/)?.[0];
                                return num ? `${num} મહિના` : "1 મહિના";
                              } else {
                                return dose.duration || "N/A";
                              }
                            })()}
                          </td>
                          <td>
                            {dose?.type_unit_ui === "Default" // Changed == to the stricter ===
                              ? (() => {
                                const { Breakfast, Lunch, Dinner } =
                                  dose.default_timing_instruction || {};

                                let timingParts = [];

                                // Logic for Breakfast
                                if (Breakfast) {
                                  timingParts.push(
                                    Breakfast === "Before"
                                      ? "નાસ્તા પહેલા"
                                      : "નાસ્તા પછી"
                                  );
                                }

                                // Logic for Lunch
                                if (Lunch) {
                                  timingParts.push(
                                    Lunch === "Before"
                                      ? "બપોરે ભોજન પહેલા"
                                      : "બપોરે ભોજન પછી"
                                  );
                                }

                                // Logic for Dinner
                                if (Dinner) {
                                  timingParts.push(
                                    Dinner === "Before"
                                      ? "રાત્રી ભોજન પહેલા"
                                      : "રાત્રી ભોજન પછી"
                                  );
                                }

                                const timingString = timingParts.join(", "); // Joins all parts with a comma and space

                                // Combine timing and note.
                                return (
                                  timingString +
                                  (dose.note ? `, ${dose.note}` : "")
                                );
                              })()
                              : (() => {
                                const timingValues = Object.values(
                                  dose?.default_timing_instruction || {}
                                );
                                const firstValue = timingValues[0];
                                let timing = "";

                                // Use if/else if for efficient and clear condition checking
                                if (firstValue === "Before Food") {
                                  timing = "ભોજન પહેલા";
                                } else if (firstValue === "After Food") {
                                  timing = "ભોજન પછી";
                                } else if (firstValue === "With Food") {
                                  timing = "ભોજન સાથે";
                                } else if (firstValue === "Empty Stomach") {
                                  timing = "ભૂખ્યા પેટે";
                                } else if (firstValue === "Bedtime") {
                                  timing = "સુવા ના સમયે";
                                } else {
                                  // Default case if the value is not recognized (optional)
                                  // You can set timing = firstValue or keep it empty
                                }

                                // Combine timing and note without unnecessary comma handling
                                return (
                                  timing +
                                  (dose.note && timing
                                    ? `, ${dose.note}`
                                    : dose.note || "")
                                );
                              })()}
                          </td>
                          <td>
                            {(() => {
                              // 1. Check the type/form of the medicine first
                              const medType = dose?.type?.toLowerCase() || "";

                              // Define types that should NOT be multiplied (remain total count 1)
                              const singleUnitTypes = [
                                "syrup", "injection", "drop", "cream", "lotion", "gel", "ointment",
                                "suspension", "spray", "soap", "inhaler", "liquid", "respule", "shampoo",
                                "suppository", "solution", "oil", "milk", "infusion", "bar", "face wash",
                                "balm", "vial", "mouthwash", "device", "patch", "serum", "enema",
                                "mouth paint", "pessary", "tube", "expectorant", "kit", "emulsion",
                                "jelly", "paste", "transpule", "cartridge", "hygiene", "paint", "elixer",
                                "spacer", "pen", "liniment", "gum paint", "wash kit", "glue", "conditioner",
                                "toothpaste", "mask", "shield", "transhaler", "gargle", "linctus",
                                "gum astringent", "octocap", "strip", "nebuliser", "vaccine", "dressing",
                                "oral solution", "aerosol", "block", "catheter", "cellular sheet", "cement",
                                "cigarette", "cloth", "concentrate", "cone", "core", "crystal", "culture",
                                "diaphragm", "disc", "dosing", "douche", "extract", "film", "gas",
                                "generator", "graft", "implant", "inhalant", "injectable", "injectable foam",
                                "insert", "intrauterine device", "irrigant", "liner", "lipstick", "packing",
                                "plaster", "poultice", "ring", "rinse", "salve", "sponge", "stick",
                                "suture", "swab", "system", "tampon", "tape", "tincture", "not applicable",
                                "note", "other"
                              ];

                              // If it matches the single unit package list, return 1 pack unit immediately
                              if (singleUnitTypes.includes(medType)) {
                                return (
                                  <strong>
                                    1 {medType || ""}
                                  </strong>
                                );
                              }

                              // 2. Parse out the duration and apply the correct time multiplier (Ref: image_de022a.png)
                              const durationStr = dose.duration?.toLowerCase() || "";
                              const rawNumber = parseInt(durationStr.match(/\d+/)?.[0] || 1, 10);

                              let durationInDays = rawNumber;
                              if (durationStr.includes("w") || durationStr.includes("week")) {
                                durationInDays = rawNumber * 7;      // Convert weeks to days
                              } else if (durationStr.includes("m") || durationStr.includes("month")) {
                                durationInDays = rawNumber * 30;     // Convert months to days
                              }

                              // 3. Determine how many times a day the medicine is taken
                              let timesPerDay = 0;
                              if (dose?.type_unit_ui === "Default" && dose?.default_timing_instruction) {
                                const { Breakfast, Lunch, Dinner } = dose.default_timing_instruction;
                                if (Breakfast) timesPerDay += 1;
                                if (Lunch) timesPerDay += 1;
                                if (Dinner) timesPerDay += 1;
                              } else if (dose?.type_unit_ui === "Alternate" && dose?.default_timing_instruction) {
                                const timingKey = Object.keys(dose.default_timing_instruction || {})[0];
                                if (timingKey === "Once") timesPerDay = 1;
                                else if (timingKey === "Twice") timesPerDay = 2;
                                else if (timingKey === "Thrice") timesPerDay = 3;
                                else if (timingKey === "4h") timesPerDay = 6;
                                else if (timingKey === "6h") timesPerDay = 4;
                                else if (timingKey === "8h") timesPerDay = 3;
                                else if (timingKey === "12h") timesPerDay = 2;
                                else if (timingKey === "48h") timesPerDay = 0.5;
                                else timesPerDay = 1;
                              } else {
                                timesPerDay = 1;
                              }

                              // 4. Convert UI string fractions (like "½", "1½") safely
                              const parseFractionQuantity = (qtyStr) => {
                                if (!qtyStr) return 0;
                                let str = String(qtyStr).trim();
                                let fractionalPart = 0;
                                if (str.includes("½")) {
                                  fractionalPart = 0.5;
                                  str = str.replace("½", "").trim();
                                }
                                const wholePart = str ? parseFloat(str) : 0;
                                return (isNaN(wholePart) ? 0 : wholePart) + fractionalPart;
                              };

                              const qtyPerDose = parseFractionQuantity(dose?.quantity);

                              // 5. Total Multiplication using the corrected days context
                              const totalCount = qtyPerDose * timesPerDay * durationInDays;

                              return totalCount > 0 ? (
                                <strong>
                                  {Number(totalCount.toFixed(2))} 
                                </strong>
                              ) : (
                                "--"
                              );
                            })()}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* Additional Sections */}
            <div className="mb-2">
              {investigations?.length > 0 && (
                <div className="mb-0">
                  <div
                    className="flex items-center gap-2"
                    onMouseEnter={() => setHoveredSection("investigations")}
                    onMouseLeave={() => setHoveredSection(null)}
                  >
                    <strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Investigations:
                    </strong>
                    <span
                      className={classNames(
                        "text-blue-500 text-sm no-print mr-2",
                        {
                          "d-inline": hoveredSection === "investigations",
                          "d-none": hoveredSection !== "investigations",
                        }
                      )}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/start-consult", {
                          state: {
                            doctorID: doctor?.id,
                            appointmentID: id,
                            activeSection: "investigations",
                          },
                        })
                      }
                    >
                      <Edit size={18} />
                    </span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <ul
                        className="sf-2"
                        style={{
                          listStyleType: "disc",
                          paddingLeft: "50px",
                          marginBottom: 0,
                        }}
                      >
                        {investigations.map((s, index) => {
                          // 1. Process the logic first
                          const details = [
                            s.date_for_test,
                            s.repeat_test_every,
                            s.note,
                          ]
                            .filter(Boolean)
                            .join(" - ");

                          const displayText = details
                            ? `${s.name} (${details})`
                            : s.name;

                          // 2. Return the JSX
                          return <li key={index}>{displayText}</li>;
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {procedures?.length > 0 && (
                <div className="mb-0">
                  <div
                    className="flex items-center gap-2"
                    onMouseEnter={() => setHoveredSection("procedures")}
                    onMouseLeave={() => setHoveredSection(null)}
                    style={{ display: "flex" }}
                  >
                    <strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Procedures:
                    </strong>
                    {procedures
                      .map((s) => {
                        const details = [
                          s.date_time,
                          s.location,
                          s.indication,
                          s.note,
                        ]
                          .filter(Boolean)
                          .join(" - ");
                        return details ? `${s.name} (${details})` : s.name;
                      })
                      .join(", ")}
                    <span
                      className={classNames(
                        "text-blue-500 text-sm no-print mr-2",
                        {
                          "d-inline": hoveredSection === "procedures",
                          "d-none": hoveredSection !== "procedures",
                        }
                      )}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/start-consult", {
                          state: {
                            doctorID: doctor?.id,
                            appointmentID: id,
                            activeSection: "procedures",
                          },
                        })
                      }
                    >
                      <Edit size={18} />
                    </span>
                  </div>
                </div>
              )}

              {instructions?.length > 0 && (
                <div className="mb-0">
                  <div
                    className="flex items-center gap-2"
                    onMouseEnter={() => setHoveredSection("instructions")}
                    onMouseLeave={() => setHoveredSection(null)}
                  // Removed the unnecessary 'display: "flex"' style
                  >
                    <strong style={{ marginLeft: "0px", marginRight: "10px" }}>
                      Instructions:
                    </strong>

                    <span
                      className={classNames(
                        "text-blue-500 text-sm no-print mr-2",
                        {
                          "d-inline": hoveredSection === "instructions",
                          "d-none": hoveredSection !== "instructions",
                        }
                      )}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate("/start-consult", {
                          state: {
                            doctorID: doctor?.id,
                            appointmentID: id,
                            activeSection: "instructions",
                          },
                        })
                      }
                    >
                      <Edit size={18} />
                    </span>
                    {/* REPLACE the comma-joined string display with a bulleted list
                     */}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <ul
                        className="sf-2"
                        style={{
                          listStyleType: "disc",
                          paddingLeft: "50px",
                          marginBottom: 0,
                        }}
                      >
                        {instructions.map((d, index) => (
                          <li key={index}>{d.name}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {prescription_notes?.length > 0 && (
                <div className="mb-0">
                  <strong>Prescription Notes:</strong>
                  <span className="ms-3 ">{prescription_notes}</span>
                </div>
              )}

              {selectedFollowUp && (
                <div className="mb-0">
                  <strong>Follow up: </strong>
                  <span className="ms-3 ">
                    {dayjs(selectedFollowUp).format("DD MMM, YYYY")}
                  </span>
                </div>
              )}
              {followUpNotes?.length > 0 && (
                <div className="mb-0">
                  <strong>Follow up Notes:</strong>
                  <span className="ms-3 ">{followUpNotes}</span>
                </div>
              )}
              {selectedDoctor && (
                <div className="mb-0">
                  <strong>Refer to:</strong>
                  <span className="ms-3 ">
                    {(() => {
                      const s = selectedDoctor;
                      if (!s) return "";

                      const details = [
                        s.speciality,
                        s.clinic_address,
                        s.clinic_numer,
                        s.mobile_numer,
                      ]
                        .filter(Boolean)
                        .join(", ");

                      return details
                        ? `${s.doctor_name}, ${details}`
                        : s.doctor_name;
                    })()}
                    ({referralInstruction})
                  </span>
                </div>
              )}
            </div>
            <hr style={{ marginBottom: "20px" }}></hr>

            {/* Footer */}
            <div className="d-flex justify-content-between align-items-end ">
              <div className="text-center">
                {/* Signature space if needed */}
              </div>
              <div className="text-end">
                <div className="text-start">
                  {settings?.doctor_signature_image_url && (
                    <div
                      className="mt-2  text-center"
                      style={{ maxWidth: "200px" }}
                    >
                      <img
                        src={settings.doctor_signature_image_url}
                        alt="Signature Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  )}
                  <div className="fw-medium">
                    Dr. {doctor.name} {doctor.last_name}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-white border-top px-4 py-3 no-print" // Changed border-bottom to border-top
        style={{
          position: "fixed", // Key: Fixes element relative to the viewport
          bottom: 0, // Key: Sticks it to the bottom edge
          left: 0, // Ensures it starts from the left edge
          width: "100%", // Ensures it spans the full width
          zIndex: 1000, // Ensures it stays on top of other content
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <Button
            variant="light"
            className="text-black d-flex align-items-center"
            onClick={async() => {
               await addConsultantData();
               navigate(-1);
            }}
          >
            <ChevronLeft size={16} className="me-2" />
            Back to Consult
          </Button>

          <div className="d-flex align-items-center gap-3">
            <Button variant="outline-secondary" onClick={() => setSaveRx(true)}>
              <Save size={16} className="me-2" />
              Save Rx
            </Button>
            {saveRx && <SaveRXModal />}

            {/* ✅ Print Button */}
            <Button
              variant="primary"
              onClick={() => {
                try {
                  if (isIpadSafari()) {
                    testPopup(); // ✔ works on iPad Safari
                  } else {
                    handlePrint(); // ✔ all other browsers
                  }
                  setprintRx(true);
                  setSaveRx(true);
                } catch (err) {
                  console.error("Print failed:", err);
                }
              }}
            >
              <Printer size={16} className="me-2" />
              Print Rx
            </Button>
          </div>
        </div>
      </div>
      <AddReferMOdal
        show={show}
        editData={doctorToEdit} // ✅ Pass the data for editing
        handleClose={handleModalClose} // ✅ Use the new centralized close handler
      />
    </div>
  );
}

